import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

const opendoorSellingOptions: FlowPage = {
  slug: () => 'selling-options-interest',
  isEnabled: () => true,
  autoAdvance: () => false,
  nextText: () => 'Next',
  hideProgress: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.exclusives_initial_seller_options_interest',
      type: 'intial_selling_options_interest',
      hide_none: true,
      options: [
        {
          label: 'Opendoor Cash',
          value: 'sell_direct',
        },
        {
          label: 'Cash Plus',
          value: 'exclusives',
        },
        {
          label: 'List with local agent',
          value: 'traditional_listing',
        },
      ],
    },
  ],
};

export default opendoorSellingOptions;
